export default {
  sm: `
  데이터센터 각이 
  실천하는 
  탄소 배출 제로
  `,
  md: `
  데이터센터 각이 실천하는 
  탄소 배출 제로
  `,
};
